import { render, staticRenderFns } from "./ProfileMenuMspForsage.vue?vue&type=template&id=4b6f5186&scoped=true"
import script from "./ProfileMenuMspForsage.vue?vue&type=script&lang=js"
export * from "./ProfileMenuMspForsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f5186",
  null
  
)

export default component.exports